// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ry","question":"e_sy","button":"e_ty","buttonNegative":"e_uy","buttonPositive":"e_vy","icon":"e_wy","iconNegative":"e_xy","iconPositive":"e_yy"};